(function () {
  const headerMobile = () => {
    const headerSection = document.querySelector(".header-mobile-section");
    const header = document.querySelector(".header-mobile");
    let scrollPos = 0;
    window.addEventListener("scroll", () => {
      if (!header.classList.contains("sticky-header")) {
        return;
      }
      const scroll = window.scrollY;
      if (scroll > 40) {
        header.classList.add("header-scroll");
      } else {
        header.classList.remove("header-scroll");
      }
      if (scroll > scrollPos) {
        // down
        if (scroll > 100) {
          hideHeader();
        } else {
          showHeader();
        }
      } else {
        // up
        showHeader();
      }
      scrollPos = scroll;
    });
    function hideHeader() {
      if (header.classList.contains("sticky-header-always")) {
        return "";
      }
      headerSection.classList.add("hide");
    }
    function showHeader() {
      headerSection.classList.remove("hide");
    }

    const burger = header.querySelector(".header-mobile__burger");
    const mobileMenu = header.querySelector(".header-mobile__menu");
    const mobileAnimateBg = header.querySelector(".animate-bg");
    const drawerOverlay = headerSection.querySelector(
      ".header-mobile__overlay",
    );
    const desktopDrawer = window.matchMedia("(min-width: 1200px)");
    const drawerTriggers = document.querySelectorAll(
      ".header-mobile-drawer-trigger",
    );
    let drawerTrigger = null;

    function setDrawerOpen(isOpen, trigger = null) {
      if (isOpen && trigger) drawerTrigger = trigger;

      header.classList.toggle("drawer-open", isOpen);
      burger.classList.toggle("active", isOpen);
      mobileMenu.classList.toggle("active", isOpen);
      mobileAnimateBg.classList.toggle("active", isOpen);
      drawerOverlay.classList.toggle("active", isOpen);
      document.body.classList.toggle("overflow-hidden", isOpen);
      burger.setAttribute("aria-expanded", String(isOpen));
      drawerTriggers.forEach((item) => {
        item.setAttribute("aria-expanded", String(isOpen));
      });

      if (desktopDrawer.matches) {
        if (isOpen) {
          header.setAttribute("aria-modal", "true");
          header.setAttribute("role", "dialog");
          header.setAttribute("aria-label", header.dataset.drawerLabel);
          requestAnimationFrame(() => trapFocus(header, burger));
        } else {
          header.removeAttribute("aria-modal");
          header.removeAttribute("role");
          header.removeAttribute("aria-label");
          removeTrapFocus(drawerTrigger);
        }
      } else if (isOpen && trigger !== burger) {
        burger.focus();
      } else if (!isOpen && drawerTrigger) {
        drawerTrigger.focus();
      }

      if (!isOpen) {
        drawerTrigger = null;
      }
    }

    burger.addEventListener("click", function (event) {
      event.preventDefault();
      setDrawerOpen(!mobileMenu.classList.contains("active"), this);
    });

    drawerTriggers.forEach((item) => {
      item.addEventListener("click", function () {
        setDrawerOpen(!mobileMenu.classList.contains("active"), this);
      });
    });

    drawerOverlay.addEventListener("click", () => setDrawerOpen(false));

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && mobileMenu.classList.contains("active")) {
        setDrawerOpen(false);
      }
    });

    const mobileMenuList = document.querySelectorAll(
      ".header-mobile__menu-header a",
    );
    mobileMenuList.forEach((item) => {
      item.addEventListener("click", function (event) {
        event.preventDefault();
        const id = this.getAttribute("href");
        mobileMenuList.forEach((_item) => {
          _item.parentElement.classList.remove("active");
        });
        this.parentElement.classList.add("active");
        const menus = document.querySelectorAll(".header-mobile__menus > li");
        const current = document.querySelector(id);
        console.log(current);
        menus.forEach((_menu) => {
          _menu.style.display = "none";
        });
        current.style.display = "block";
      });
    });
  };

  document.addEventListener("shopify:section:load", headerMobile);
  headerMobile();
})();
